import React from 'react';
import { Container } from './styles';
import { ScreenForm } from './components/ScreenForm';
import FooterDefault from '~/components/FooterDefault';
import { CustomDataGrid } from './components/CustomDataGrid';
import { Totalizadores } from './components/Totalizadores';
import { PrintButton } from './components/PrintButton';
import { ButtonAcessaReprocessa } from './components/ButtonAcessaReprocessa';
import FormDefault from '~/components/FormDefault';

export const ApuracaoDePisCofinsContent: React.FC = () => {
  return (
    <Container>
      <FormDefault
        codTela={295}
        title="Apuração de Pis/Cofins"
        onSave={() => Promise.resolve()}
        onCancel={() => []}
        onClearFields={() => []}
        onNew={() => []}
        onDelete={() => []}
        onReturnSearch={() => []}
        isDelete={false}
        isNew={false}
        isCancel={false}
        isClear={false}
        isSave
        customButtons={
          <>
            <ButtonAcessaReprocessa />
            <PrintButton />
          </>
        }
      >
        <article className="main-content">
          <ScreenForm />
          <CustomDataGrid />
        </article>
        <article className="totalizadores-buttons">
          <Totalizadores />
        </article>
      </FormDefault>
    </Container>
  );
};
